import { useState } from 'react'
import Container from 'react-bootstrap/Container'

import ClubSummaryHeader from './components/ClubSummaryHeader/ClubSummaryHeader'
import ClubSummaryOverview from './components/ClubSummaryOverview/ClubSummaryOverview'
import ClubSummaryCoupons from './components/ClubSummaryVouchers/ClubSummaryCoupons'
import ClubSummaryRewards from './components/ClubSummaryVouchers/ClubSummaryRewards'

import { CONTENT_WINDOWS } from './constants'

import './ClubSummary.scss'

const ClubSummary = ({ coupons, rewards, transactions, userPoints, sectionRef }) => {
    const [activeWindow, setActiveWindow] = useState(CONTENT_WINDOWS.OVERVIEW)

    return (
        <Container fluid className="club-summary d-flex flex-column">
            <ClubSummaryHeader setActiveWindow={setActiveWindow} activeWindow={activeWindow} />
            <Container fluid className="club-summary--content">
                {activeWindow === CONTENT_WINDOWS.COUPONS && <ClubSummaryCoupons coupons={coupons} />}
                {activeWindow === CONTENT_WINDOWS.REWARDS && (
                    <ClubSummaryRewards rewards={rewards} userPoints={userPoints} />
                )}
                {activeWindow === CONTENT_WINDOWS.OVERVIEW && (
                    <ClubSummaryOverview transactions={transactions} points={userPoints} sectionRef={sectionRef} />
                )}
            </Container>
        </Container>
    )
}

export default ClubSummary
